import { FC, useEffect, useRef, useState } from "react";
import styles from "./buyer.module.scss";
import useRWD from "../../componsnts/hooks/useRWD";
import { DeviceType } from "../../componsnts/hooks/useRWD";
import CustomModal from "../../componsnts/common/registerModal/modal";
import { useMutation } from "react-query";
import registratoionService from "../../service/register/registration";
import { RegistrationFormData } from "../../models/registrationModel"
import toast from 'react-hot-toast';
import MsgModal from "../../componsnts/common/customModal/customModal";


const Buyer: FC = () => {
  const [isMsgModalOpen, setIsMsgModalOpen] = useState(false);
  const [modalMessageOpen, setModalMessageOpen] = useState('');
  const [modalTitle, setModalTitle] = useState("");

  useEffect(() => {
    window.scrollTo({
      top: 0,
    });
  }, [])


  const [formData, setFormData] = useState<RegistrationFormData>({
    AccountRole: 0,
    CompanyName: "",
    CompanyTax: "",
    ContacterName: "",
    ContacterPhone: "",
    Email: "",
    Password: "",
  });

  const handleFormSubmit = (data: RegistrationFormData) => {
    setFormData(data);
    buyerRegistration(data);
  };

  const {
    mutate: buyerRegistration, isLoading: registrationLoaing
  } = useMutation({
    mutationFn: (data: RegistrationFormData) => registratoionService.handleRegistration(data),
    onSuccess: (res) => {
      if (res.Success) {
        mesModal('註冊成功，請至信箱收取驗證信。')
      } else {
        mesModal(`註冊失敗: ${res.Message}`)
      }
    },
    onError: (err) => {
      mesModal(`註冊失敗: ${err}`)
    },
  });

  const mesModal = (msg: string) => {
    setIsMsgModalOpen(true)
    setModalMessageOpen(msg)
  }

  const closeModal = () => {
    setIsMsgModalOpen(false);
  };


  return (
    <div className={styles["login_container"]}>
      <MsgModal isOpen={isMsgModalOpen} onClose={closeModal} message={modalMessageOpen}></MsgModal>
      <div className="login_box">
        <div className="background_image"></div>
        <CustomModal
          isOpen={true}
          title={modalTitle}
          iAmBuyer={true}
          registrationLoaing={registrationLoaing}
          onSubmit={handleFormSubmit} // 傳遞回調函數
        />
      </div>
    </div>
  );
};
export default Buyer;
